<template>
  <div :id="this._uid" style="display: none">
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script type="text/babel">
  import GoogleMapChildren from './GoogleMapChildren'

  export default {
    name: 'GoogleMapCircle',
    extends: GoogleMapChildren,
    beforeDestroy() {
      if (this.info_item) {
        this.info_item.close()
      }
    },
    methods: {
      init: function () {
        if (this.item == null) {

          var self = this

          this.item = new google.maps.Circle({
            strokeColor: self.strokeColor,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: self.fillColor,
            fillOpacity: 0.35,
            map: this.getMap(),
            center: new google.maps.LatLng(self.position.lat, self.position.lng),
            radius: self.radius
          });

          if (this.forceInfo || typeof this.$slots.default != 'undefined') {
            this.info_item = new google.maps.InfoWindow({
              content: document.getElementById(self._uid).firstChild,
            })

            this.item.addListener('click', function (circle) {
              self.info_item.setPosition(new google.maps.LatLng(self.position.lat, self.position.lng));
              self.info_item.open(self.$parent.getMap(), self.item);
            });

          }
        }
      }
    },
    props: {
      forceInfo: {
        type: Boolean,
        default: false
      },
      position: {
        type: Object,
        required: true
      },
      radius: {
        type: Number,
        default: 50
      },
      strokeColor: {
        type: String,
        default: "#ff6b0c"
      },
      fillColor: {
        type: String,
        default: "#ff6b0c"
      }
    },
    watch: {
      position: function () {
        if (this.item) {
          this.item.setCenter(new google.maps.LatLng(this.position.lat, this.position.lng));
          this.item.setRadius(this.radius)
        }
      },
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// GoogleMapCircle.vue?5703f27d